import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';
import FlagIcon from '@mui/icons-material/Flag';
import { Box } from '@mui/material';
import { LYFT_RIDE_STATUSES } from './constants';

const LyftRideInfo = {
    scheduled: {
        title: "Ride Scheduled",
        description: "The ride is scheduled for the requested time.",
        icon: <FlagIcon />
    },
    pending: {
        title: "Ride Requested for Customer",
        description: "We're finding a nearby driver for the customer.",
        icon: <DirectionsCarIcon />
    },
    accepted: {
        title: "Driver Assigned",
        description: "A driver is on the way to pick up the customer.",
        icon: <CheckCircleIcon />
    },
    arrived: {
        title: "Driver Has Arrived",
        description: "The driver has reached the pickup location.",
        icon: <LocationOnIcon />
    },
    pickedUp: { 
        title: "Customer Picked Up",
        description: "The customer is now on the way to his destination.",
        icon: <DepartureBoardIcon />
    },
    droppedOff: {
        title: "Customer Dropped Off",
        description: "The customer has arrived at his destination.",
        icon: <FlagIcon />
    }
}

const LyftRideType = {
  lyft: "Standard Lyft Ride. Curb-to-curb offering for up to 4 passengers.",
  lyft_assisted: "Door-to-door light / curb-to-curb + offering. The driver may provide light assistance for the passenger.",
  lyft_plus: "A supersized ride when you need more space. Fits up to 6 people.",
  lyft_premier: "Get extra legroom, newer cars, and top-rated driver.",
  lyft_lux: "A black car for the ultimate luxury ride. Fits up to 4 people.",
  lyft_luxsuv: "A more spacious black car, offering a luxury ride for up to 6 people.",
  lyft_priority_pickup: "Upgrade to Priority Pickup for a faster pickup when you're in a hurry.",
  lyft_wait_and_save: "Save money by waiting a little longer for less urgent trips.",
  lyft_access: "Wheelchair Accessible Vehicles (WAV)."
}

const isCourtesyRideInProgress = (WO, isCourtesyRidesEnabled) => {
  if(isCourtesyRidesEnabled && WO?.CourtesyRidesData) {
    const rideStatus = WO?.CourtesyRidesData[0].status

    if(rideStatus === undefined) 
      return false;
  
    const inProgressStatuses = [
      LYFT_RIDE_STATUSES.pending, 
      LYFT_RIDE_STATUSES.accepted, 
      LYFT_RIDE_STATUSES.arrived, 
      LYFT_RIDE_STATUSES.pickedUp
    ];
  
    return inProgressStatuses.includes(rideStatus);

  }

  return false;

}

const formatLyftAddress = (address) => {
  const parts = address.split(',').map(p => p.trim());

  return <Box className='w-2/3'>
    <h6 className='text-base font-semibold'>
      {parts[0]}
    </h6>
    <span className='text-sm'>
      {parts[1]}, {parts[2]}
    </span>
  </Box>
}

export { LyftRideInfo, formatLyftAddress, LyftRideType, isCourtesyRideInProgress };